import { type ChangeEvent, useMemo } from "react";
import type MultiSelectProperties from "./MultiSelect.properties.ts";
import type { MultiValue } from "react-select";
import type { SelectType } from "../shared/select/Select.type.ts";

export const useMultiSelectController = (props: MultiSelectProperties) => {
  const selectedOptions: SelectType[] = useMemo(
    () => props.data.filter((o) => props.selectedValues.includes(o.value)),
    [props],
  );

  const handleChange = (selected: MultiValue<SelectType>) => {
    const selectedIds = selected.map((s) => s.value);

    props.handleChange({
      target: { value: JSON.stringify(selectedIds) },
    } as ChangeEvent<HTMLSelectElement>);
  };

  return {
    selectedOptions,
    handleChange,
  };
};
